export class ParseConsistentBase64JsonPayloadUseCase {
    constructor(crypto) {
        this.crypto = crypto;
    }
    execute(stringifiedData) {
        return JSON.parse(this.crypto.base64Decode(stringifiedData));
    }
}
